module.exports = __webpack_public_path__ + "_assets/img/book02.8d49c4fe.svg";